module.exports = __webpack_public_path__ + "static/media/cozenMenu.d53d5bad.pdf";